module.exports = __webpack_public_path__ + "components/page-header/static/tide-badge--light-7e790cae264ab193244bc104b69f5155.svg";